import { useEffect, useState } from "react";
import { userEmailValidate, userMobileValidate, userRegister } from "../services/userService";
import { useNavigate } from "react-router-dom";
import Loader2 from "../components/common/Loader2";
import { validateLoginScreen } from "../services/validate-login";

export default function Register() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    password: "",
    referral_code: "",
  });
  const [formIsComplete, setFormIsComplete] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [step, setStep] = useState<"form" | "email" | "phone">("form"); // 👈 step control
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [eCheck, setECheck] = useState(false);

  useEffect(() => {
    validateLoginScreen(navigate);
  }, []);
  
  const checkForm = () => {
    if(formData.name !== "" && formData.mobile.length === 10 && eCheck && formData.password.length >=8){
      setFormIsComplete(true)
    }else{
      setFormIsComplete(false)
    }
  }

  const validatePassword = (value: string) => {
    console.log(value)
    // const contactRegex = /^[6-9]\d{9}$/;
    // if (!contactRegex.test(value)) {
    //   checkForm();
    //   setFormIsComplete(false)
    //   setPhoneError("Enter a valid 10-digit mobile number starting with 6-9");
    // } else {
    //   if(value.length === 10) checkForm();
    //   setPhoneError("");
    // }
  };


  const validateContact = (value: string) => {
    const contactRegex = /^[6-9]\d{9}$/;
    if (!contactRegex.test(value)) {
      checkForm();
      setFormIsComplete(false)
      setPhoneError("Enter a valid 10-digit mobile number starting with 6-9");
    } else {
      if(value.length === 10) checkForm();
      setPhoneError("");
    }
  };

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(value)) {
      setFormIsComplete(false)
      setECheck(false)
      setEmailError("Invalid email format (e.g., example@mail.com)");
    } else {
      setECheck(true)
      setEmailError("");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if(e.target.name === "password"){
      var len =e.target.value.length
      if(len >= 8){
        setPasswordError("")
      }else{
        setPasswordError("Minimum 8 characters required")
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      var data = {
          "mobile": "91"+formData.mobile,
          "name": formData.name,
          "password": formData.password,
          "email": formData.email,
          "referral_code":formData.referral_code
      }
      console.log("Form submitted:", data);
      setLoading(true)
      const response = await userRegister(data);
      setLoading(false)
      if (response.success) {
        setStep("email");
      } else {
        console.log(response)
        alert(response.message);
      }
    } catch (error: any) {
      console.error("Login failed:", error);
      const message =
        error?.response?.data?.message ||
        "Login failed: Invalid email or password.";
      alert(message);
    }
  };

  const handleEmailVerification = async () => {
    // 👇 Normally you’ll call API to verify email
    console.log("Email verified with OTP:", otp);
    try {
      var data = {
          "email": formData.email,
          "mobile": "91"+formData.mobile,
          "code": otp,
          "new_user": true
      } 
      console.log("Form submitted:", data);
      setLoading(true)
      const response = await userEmailValidate(data);
      setLoading(false)
      console.log(response)
      if (response.success) {
        setOtp("")
        // ✅ Open email verification dialog
        setStep("phone");
      } else {
        alert("Invalid Email OTP.");
      }
    } catch (error: any) {
      console.error("Login failed:", error);
      const message =
        error?.response?.data?.message ||
        "Login failed: Invalid email or password.";
      alert(message);
    }
  };

  const handlePhoneVerification = async () => {
    // 👇 Normally you’ll call API to verify phone
    console.log("Phone verified with OTP:", otp);
        try {
      var data = {
        "email": formData.email,
        "mobile": "91"+formData.mobile,
        "secret_key": "secret_key",
        "code": otp,
        "device": "web"
      } 
      console.log("Form submitted:", data);
      setLoading(true)
      const response = await userMobileValidate(data);
      console.log(2)
      setLoading(false)
      console.log(response)
      if (response.success) {
        localStorage.setItem("role", response.message.role);
        localStorage.setItem("customer_id", response.message.customer_id);
        localStorage.setItem("user", response.message.user);
        localStorage.setItem("user_photo", response.message.user_photo);
        localStorage.setItem("access_token", response.message.access_token);
        window.location.reload();
        // ✅ Open email verification dialog
        navigate("/dashboard"); // redirect to dashboard
      } else {
        alert("Invalid Mobile OTP.");
      }
    } catch (error: any) {
      console.error("Login failed:", error);
      const message =
        error?.response?.data?.message ||
        "Login failed: Invalid email or password.";
      alert(message);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f5f9ff]">
        <Loader2 />
      </div>
    );
  }

  return (
    <>
      {/* Registration Form */}
      {step === "form" && (
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              alt="MIRO Labs Pvt. Ltd."
              src="logo_with_name.png?color=indigo&shade=600"
              className="mx-auto h-10 w-auto"
            />
            <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-gray-900">
              Sign up for an account
            </h2>
          </div>

          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-900">
                  Name
                </label>
                <input
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onKeyUp={checkForm}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900">
                  Mobile
                </label>
                <input
                  name="mobile"
                  type="number"
                  required
                  value={formData.mobile}
                  onKeyUp={checkForm}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                    validateContact(val);
                  }}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
                />
                {phoneError && (
                  <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                )}
              </div>

              {/* Personal Email */}
              <div>
                <label className="block text-sm font-medium text-gray-900">
                  Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onKeyUp={(e) => checkForm()}
                  onChange={(e) => {
                    const val = e.target.value.trim();
                        setFormData({
                          ...formData,
                          ["email"]: val,
                        });
                        validateEmail(val)
                  }}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
                />
                {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900">
                  Password
                </label>
                <input
                  name="password"
                  type="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  onKeyUp={checkForm}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
                />
                {passwordError && <p className="text-red-500 text-sm mt-1">{passwordError}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900">
                  Referral Code (<i>Optional</i>)
                </label>
                <input
                  name="referral_code"
                  type="text"
                  value={formData.referral_code}
                  onChange={handleChange}
                  onKeyUp={checkForm}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2"
                />
              </div>

              <button
                type="submit"
                disabled={!formIsComplete}
                className={`w-full px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${!formIsComplete
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"}`}
              >
                Register
              </button>
            </form>
            <p className="mt-10 text-center text-sm text-gray-500">
            Already a member?{' '}
            <a href="login" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Login
            </a>
          </p>
          </div>
        </div>
      )}

      {/* Email Verification Modal */}
      {step === "email" && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Verify Your Email
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Enter the OTP sent to your email <b>{formData.email}</b>.
            </p>
            <input
              type="text"
              placeholder="Enter Email OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4"
            />
            <button
              onClick={handleEmailVerification}
              className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-500"
            >
              Verify Email
            </button>
          </div>
        </div>
      )}

      {/* Phone Verification Modal */}
      {step === "phone" && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Verify Your Phone
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Enter the OTP sent to your mobile <b>{formData.mobile}</b>.
            </p>
            <input
              type="text"
              placeholder="Enter Phone OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4"
            />
            <button
              onClick={handlePhoneVerification}
              className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-500"
            >
              Verify Phone
            </button>
          </div>
        </div>
      )}
    </>
  );
}
